import { Roles } from 'model';
import { useUserHasRole } from '../hooks/useUserHasRole';
import React from 'react';
export const FeatureGate: React.FC<{
	children: React.ReactNode;
	role: Roles;
	hide?: boolean;
}> = ({ children, role, hide = false }) => {
	const hasRole = useUserHasRole(role);
	return !hasRole || hide ? null : <>{children}</>;
};
